/* Shop by category rail — a continuous marquee.

   Rewritten 29 Oct 2026 for speed: the old version moved the track's
   scrollLeft on every animation frame, which forces layout each frame and
   cost the home page seconds of main-thread time on a phone (Lighthouse:
   the single largest script cost on the site). Now the cards sit on a
   "belt" inside the track and the belt is moved with a compositor-driven
   transform animation (Web Animations API): no per-frame JavaScript, no
   layout. The card list is duplicated once and the animation loops over
   exactly one set's width, which lands on a visually identical frame.

   Pauses on hover, on keyboard focus, on touch and when the tab is hidden.
   Never runs under prefers-reduced-motion or when every card already fits —
   the arrows and native scrolling still work in every case. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canAnimate = typeof Element !== 'undefined' && !!Element.prototype.animate;

  function initRail(rail) {
    if (!rail || rail.dataset.railReady) return;
    rail.dataset.railReady = '1';
    var track = rail.querySelector('[data-catrail-track]');
    var prev = rail.querySelector('[data-catrail-prev]');
    var next = rail.querySelector('[data-catrail-next]');
    if (!track) return;

    var originals = [].slice.call(track.querySelectorAll('[data-catrail-item]'));
    if (originals.length < 2) return;

    var speed = parseFloat(rail.getAttribute('data-speed')) || 55; // px per second
    var wantsAuto = rail.getAttribute('data-autoplay') === 'true' && !reduceMotion && canAnimate;
    var paused = false;
    var belt = null, anim = null, cloned = false, setW = 0;

    function ensureBelt() {
      if (belt) return;
      belt = document.createElement('div');
      belt.className = 'lum-catrail__belt';
      while (track.firstChild) belt.appendChild(track.firstChild);
      track.appendChild(belt);
      track.classList.add('has-belt');
    }
    function cloneOnce() {
      if (cloned) return;
      originals.forEach(function (el) {
        var copy = el.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('tabindex', '-1');
        copy.removeAttribute('data-catrail-item');
        copy.setAttribute('data-catrail-clone', '');
        belt.appendChild(copy);
      });
      cloned = true;
    }
    function stride() {
      var first = originals[0].getBoundingClientRect();
      var second = originals[1].getBoundingClientRect();
      return second.left - first.left;
    }
    function setWidth() { return stride() * originals.length; }
    function overflows() { return track.scrollWidth - track.clientWidth > 4; }

    function start() {
      if (!wantsAuto || anim || !overflows()) return;
      ensureBelt();
      cloneOnce();
      setW = setWidth();
      if (!(setW > 0)) return;
      // free scrolling while the marquee runs; snap would fight it
      track.style.scrollSnapType = 'none';
      anim = belt.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(-' + setW + 'px)' }],
        { duration: (setW / speed) * 1000, iterations: Infinity, easing: 'linear' }
      );
      if (paused || document.hidden) anim.pause();
    }
    function stop() {
      if (anim) { anim.cancel(); anim = null; }
    }
    function setPaused(p) {
      paused = p;
      if (!anim) return;
      if (p || document.hidden) anim.pause(); else anim.play();
    }

    function stepBy(dir) {
      var s = Math.round(stride());
      if (anim && setW > 0) {
        // jump the animation by one card, staying inside one loop
        var dur = (setW / speed) * 1000, ms = (s / speed) * 1000;
        var t = (Number(anim.currentTime) || 0) + dir * ms;
        t = ((t % dur) + dur) % dur;
        anim.currentTime = t;
        return;
      }
      var target = track.scrollLeft + s * dir;
      var max = track.scrollWidth - track.clientWidth;
      if (target < 0) target = max;
      if (target > max) target = 0;
      track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { stepBy(-1); });
    if (next) next.addEventListener('click', function () { stepBy(1); });

    ['mouseenter', 'focusin', 'pointerdown'].forEach(function (evt) {
      rail.addEventListener(evt, function () { setPaused(true); }, { passive: true });
    });
    ['mouseleave', 'focusout', 'pointerup', 'pointercancel'].forEach(function (evt) {
      rail.addEventListener(evt, function () {
        if (evt === 'focusout' && rail.contains(document.activeElement)) return;
        if (evt !== 'focusout' && rail.matches(':hover') && evt === 'pointerup') return;
        setPaused(false);
      }, { passive: true });
    });
    document.addEventListener('visibilitychange', function () { setPaused(paused); });

    function sync() {
      var show = overflows();
      if (prev) prev.hidden = !show;
      if (next) next.hidden = !show;
      if (!show) { stop(); return; }
      if (anim && cloned && Math.abs(setWidth() - setW) > 1) stop(); // a resize changed the card width
      start();
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(sync, 150);
    });

    // wait for images so the measured set width is final
    if (document.readyState === 'complete') sync();
    else window.addEventListener('load', sync);
  }

  function initAll() { document.querySelectorAll('[data-catrail]').forEach(initRail); }

  // rails whose cards arrive later (New in-store fetches them) call this
  window.LumRailInit = initRail;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
